import { generatePath } from 'react-router';
import { getEndpointUrl } from '../config';
import { analyticsPush } from '../actions/applicationActions';
import { RATEPLAN_VOUCHER_CHECK } from '../constants/ActionTypes';
import { EVT_VOUCHER_VALIDATED } from '../constants/EventTypes';
import {
	VOUCHER_ACCEPTED,
	VOUCHER_INVALID,
	VOUCHER_EXPIRED,
	VOUCHER_ALREADY_USED,
} from '../constants/ErrorTypes';
import {
	ROUTE_MESSAGES_ERROR_TERMED,
	ROUTE_MESSAGES_ERROR_CANCELLATION_PERIOD,
	ROUTE_MESSAGES_ERROR_SUBSCRIPTION_INCOMPATIBILITY,
	ROUTE_MESSAGES_ERROR_SUBSCRIPTION_PAUSED,
	ROUTE_MESSAGES_ERROR_MULTIPLE_SUBSCRIPTION,
	ROUTE_MESSAGES_ERROR_ALREADY_TRUSTED_PARTY,
	ROUTE_MESSAGES_ERROR_TERMED_NPL,
} from '../constants/Routes';
import history from '../../common/history';
import { RESELLER_IDS } from '../constants/ResellersAndPartners';
import { isPriceIncreasePlan } from '../helpers/plan';

export const checkVoucher = (actionCode, currentPlanId) => (dispatch) => {
	dispatch({
		type: `${RATEPLAN_VOUCHER_CHECK}_PENDING`,
	});

	return dispatch({
		type: RATEPLAN_VOUCHER_CHECK,
		payload: {
			client: 'subscriptionService',
			method: 'GET',
			url: getEndpointUrl('v2_voucher_check', {
				actionCode,
			}),
		},
	})
		.then(({ payload }) => {
			const action = getVoucherStatusAction({ ...payload, currentPlanId });
			const {
				isValid,
				voucherInvalidReason,
				redemptionLeadsToPromoLoss,
				redemptionLeadsToSuspensionOfCurrentSubscription,
			} = payload;

			dispatch(
				analyticsPush({
					event: EVT_VOUCHER_VALIDATED,
					voucher: {
						isValid,
						voucherInvalidReason,
						redemptionLeadsToPromoLoss,
						redemptionLeadsToSuspensionOfCurrentSubscription,
					},
				})
			);

			return dispatch(action);
		})
		.catch(() => {
			dispatch({
				type: `${RATEPLAN_VOUCHER_CHECK}_ERROR`,
				payload: {
					hasError: true,
					status: VOUCHER_INVALID,
				},
			});
		});
};

function onIrredeemable(path) {
	return history.push(path);
}

function onInvalid(errorType) {
	return {
		type: `${RATEPLAN_VOUCHER_CHECK}_ERROR`,
		payload: {
			hasError: true,
			status: errorType,
		},
	};
}

function getVoucherStatusAction({
	isValid,
	planId,
	reseller,
	ratePlanCode,
	voucherIrredeemableReason,
	voucherInvalidReason,
	redemptionLeadsToPromoLoss,
	redemptionLeadsToSuspensionOfCurrentSubscription,
	currentPlanId,
	canBeRedeemed,
}) {
	switch (voucherIrredeemableReason) {
		case 'cancellationInProgress':
			return onIrredeemable(ROUTE_MESSAGES_ERROR_CANCELLATION_PERIOD);
		case 'alreadyOnVoucher':
			if (reseller === RESELLER_IDS.NPL && isPriceIncreasePlan(currentPlanId)) {
				return onIrredeemable(ROUTE_MESSAGES_ERROR_TERMED_NPL);
			}
			return onIrredeemable(ROUTE_MESSAGES_ERROR_TERMED);
		case 'alreadyMultipleSubscriptions':
			return onIrredeemable(ROUTE_MESSAGES_ERROR_MULTIPLE_SUBSCRIPTION);
		case 'incompatibleWithSubscription':
			return onIrredeemable(ROUTE_MESSAGES_ERROR_SUBSCRIPTION_INCOMPATIBILITY);
		case 'subscriptionCannotBePaused':
			return onIrredeemable(ROUTE_MESSAGES_ERROR_SUBSCRIPTION_PAUSED);
		case 'hasActiveTrustedPartySubscription':
			return onIrredeemable(
				generatePath(ROUTE_MESSAGES_ERROR_ALREADY_TRUSTED_PARTY, { partnerName: reseller })
			);
	}

	switch (voucherInvalidReason) {
		case 'alreadyUsed':
			return onInvalid(VOUCHER_ALREADY_USED);
		case 'expired':
			return onInvalid(VOUCHER_EXPIRED);
		case 'notFound':
		case 'unknown':
			return onInvalid(VOUCHER_INVALID);
	}

	if (!isValid || !canBeRedeemed) {
		return {
			type: `${RATEPLAN_VOUCHER_CHECK}_ERROR`,
			payload: {
				hasError: true,
				status: VOUCHER_INVALID,
			},
		};
	}

	return {
		type: `${RATEPLAN_VOUCHER_CHECK}_SUCCESS`,
		payload: {
			hasError: false,
			status: VOUCHER_ACCEPTED,
			planId: planId,
			reseller,
			ratePlanCode,
			redemptionLeadsToPromoLoss,
			redemptionLeadsToSuspensionOfCurrentSubscription,
		},
	};
}
